import React from 'react';
import { ActionOutputItem } from './ActionOutputItem';
import { ActionModel } from '../models/ActionModel';
import './ActionList.less';

export interface IActionListProps {
  actions: ActionModel[];
  showAddLink: boolean;
  onAddActionClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  isDebug: boolean;
}

/**
 *  List of actions which will be triggered for truly outcome
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function ActionList({ actions, showAddLink, onAddActionClick, isDebug }: IActionListProps) {
  return (
    <ul className="outcome-action-list">
      {actions.map(item => (
        <ActionOutputItem
          key={item.ActionId}
          action={item}
          isDebug={isDebug}
          handler={item.getHandler()}
          sessionId={item.getSessionId()}
        />
      ))}
      {/* TODO alex: add ButtonLink component and use it here */}
      {showAddLink && !isDebug && (
        // TODO alex: maybe need to move out "add" button
        <button className="outcome-action-list__add link" onClick={onAddActionClick}>
          Add
        </button>
      )}
    </ul>
  );
}
